import React from 'react'
import './StudentPlan.scss';
import StudentPlanImage from '../../../../assets/StudentPlanImage.png';

export default function StudentPlan() {
  return (
    <div className='student-plan-container'>
      <div className='left-section'>
        <h1>Are you a Student?</h1>
        <p>
            If you’re a student, enjoy all premium features completely free. You’ll get unlimited tool usage, no ads, and 50 coins every day just verify your student status to unlock this special plan. 
        </p>
        <p>Note: Your application will be reviewed and approved within 2–3 working days.</p>
      </div>
      <div className='right-section'>
        <img src={StudentPlanImage} alt="student plan" />
      </div>
    </div>
  )
}
